import api from './api';
import { ApiResponse, PageResponse, School } from '../types';

export interface Organization {
  id: number;
  name: string;
  code: string | null;
  contactName: string | null;
  contactPhone: string | null;
  status: string;
  adminCount: number;
  schoolCount: number;
  createdAt: string;
  brandName?: string | null;
  brandSubtitle?: string | null;
  brandLogoUrl?: string | null;
  brandColor?: string | null;
}

export interface AdminAccount {
  id: number;
  username: string;
  displayName: string;
  organizationId: number | null;
  organizationName: string | null;
  status: string;
}

export interface OrgRequest {
  name: string;
  code?: string;
  contactName?: string;
  contactPhone?: string;
  notes?: string;
}

export interface CreateAdminRequest {
  username: string;
  password: string;
  displayName: string;
  organizationId: number;
}

export const orgManagementService = {
  listOrgs: async (): Promise<Organization[]> =>
    (await api.get<ApiResponse<Organization[]>>('/admin/org-management/organizations')).data.data,

  createOrg: async (body: OrgRequest): Promise<Organization> =>
    (await api.post<ApiResponse<Organization>>('/admin/org-management/organizations', body)).data.data,

  updateOrg: async (id: number, body: OrgRequest): Promise<Organization> =>
    (await api.put<ApiResponse<Organization>>(`/admin/org-management/organizations/${id}`, body)).data.data,

  updateBranding: async (
    id: number,
    body: { brandName?: string | null; brandSubtitle?: string | null; brandLogoUrl?: string | null; brandColor?: string | null }
  ): Promise<Organization> =>
    (await api.put<ApiResponse<Organization>>(`/admin/org-management/organizations/${id}/branding`, body)).data.data,

  deleteOrg: async (id: number): Promise<void> => {
    await api.delete(`/admin/org-management/organizations/${id}`);
  },

  assignSchool: async (schoolId: number, organizationId: number | null): Promise<void> => {
    await api.put(`/admin/org-management/schools/${schoolId}/organization`, { organizationId });
  },

  listAdmins: async (): Promise<AdminAccount[]> =>
    (await api.get<ApiResponse<AdminAccount[]>>('/admin/org-management/admins')).data.data,

  createAdmin: async (body: CreateAdminRequest): Promise<AdminAccount> =>
    (await api.post<ApiResponse<AdminAccount>>('/admin/org-management/admins', body)).data.data,

  updateAdminOrg: async (id: number, organizationId: number | null): Promise<AdminAccount> =>
    (await api.put<ApiResponse<AdminAccount>>(`/admin/org-management/admins/${id}/organization`, { organizationId })).data.data,

  updateAdminStatus: async (id: number, status: 'ACTIVE' | 'SUSPENDED'): Promise<AdminAccount> =>
    (await api.put<ApiResponse<AdminAccount>>(`/admin/org-management/admins/${id}/status`, { status })).data.data,

  resetAdminPassword: async (id: number, newPassword: string): Promise<void> => {
    await api.put(`/admin/org-management/admins/${id}/password`, { newPassword });
  },

  // 学校分配 UI 用：超管可见全部学校（分页）
  listSchools: async (): Promise<School[]> =>
    (await api.get<ApiResponse<PageResponse<School>>>('/admin/schools', {
      params: { page: 0, size: 1000, sortBy: 'id', sortDir: 'ASC' },
    })).data.data.content,
};
